import React from "react";
import "./style.css";
import { Button } from "../Button/Button";
import { Link } from "react-router-dom";
import { Reveal } from "../Reveal/Reveal";
import logo from "../../Assets/WHITE.webp";
import ButtonMailto from "../MailToButton/ButtonMailTo";

export const Footer = (prop) => {
  return (
    <footer className="container-style">
      <div className="content-sizing footer-wrapper">
        <div className="top-footer-section">
          <div className="left-side-footer">
            <img src={logo} width={20} alt="light logo" loading="lazy" />
            <p>
              Our mission is to reshape the digital landscape with cutting-edge
              solutions that drive your success, foster innovation, and empower
              thriving businesses and industries.
            </p>
            <p>
              We firmly believe in the transformative power of software to
              revolutionize industries, optimize operations, and enrich lives,
              propelling us towards a brighter, more connected future.
            </p>
          </div>
          <div className="right-side-footer">
            <h3>Let’s get started on something great</h3>
            <p>
              Our team of IT experts looks forward to meeting with you and
              providing valuable insights tailored to your business.
            </p>
            <Button onClick={() => prop.setIsOpen(true)}>
              Get an appointment now
            </Button>
            {/* <ul>
              <li>
                <h3>2 <h4>Mins</h4></h3>
                <p>Response Time</p>
              </li>
              <li>
                <h3>99%</h3>
                <p>Client Satisfaction</p>
              </li>
              <li>
                <h3>10+ <h4>Years</h4></h3>
                <p>Field Experience</p>
              </li>
            </ul> */}
          </div>
        </div>

        <div className="useful-links-footer">
          <div className="useful-left-link">
            <div className="single-link-col">
              <h4>Services</h4>
              <ul>
                <li
                  id="menu-item-2879"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2879"
                >
                  <Link to="/services/development">Software Development</Link>
                </li>
                <li
                  id="menu-item-2880"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2880"
                >
                  <Link to="/services/e-commerces">E-Commerces</Link>
                </li>
                <li
                  id="menu-item-2881"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2881"
                >
                  <Link to="/services/it">IT Support</Link>
                </li>
                <li
                  id="menu-item-2882"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2882"
                >
                  <Link to="/services/web">Web Applications</Link>
                </li>
                <li
                  id="menu-item-2882"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2882"
                >
                  <Link to="/services/crm">CRM Solutions</Link>
                </li>
                <li
                  id="menu-item-2882"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2882"
                >
                  <Link to="/services/management">Management</Link>
                </li>
              </ul>
            </div>

            <div className="single-link-col">
              <h4>Quick Links</h4>
              <ul>
                <li
                  id="menu-item-2880"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2880"
                >
                  <Link to="/">Home</Link>
                </li>
                <li
                  id="menu-item-2879"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2879"
                >
                  <Link to="/about-us">About Us</Link>
                </li>
                <li
                  id="menu-item-2880"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2880"
                >
                  <Link to="/services/general">Services</Link>
                </li>
                <li
                  id="menu-item-2880"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2880"
                >
                  <Link to="/faq">FAQ</Link>
                </li>
                <li
                  id="menu-item-2880"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2880"
                >
                  <Link to="/contact-us">Contact</Link>
                </li>
              </ul>
            </div>

            <div className="single-link-col">
              <h4>Legal</h4>
              <ul>
                <li
                  id="menu-item-2879"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2879"
                >
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li
                  id="menu-item-2880"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2880"
                >
                  <Link to="/term-and-condition">Terms of Service</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="contact-info-bottom-footer">
            <div>
              <h3>Phone</h3>
              <p>+1 204-333-4080</p>
            </div>

            <div>
              <h3>Mail</h3>
              <p>
                <ButtonMailto
                  label="datadept.ca@gmail.com"
                  mailto="mailto:datadept.ca@gmail.com"
                />
              </p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 All rights reserved by DataDept&trade;</p>
        </div>
      </div>

      <img
        decoding="async"
        src="https://wpriverthemes.com/synck/wp-content/uploads/2024/03/bg-shape-4.svg"
        alt="Shape"
        class="slide-left"
        loading="lazy"
      />
    </footer>
  );
};
